/* eslint-disable array-callback-return */
import React, { useCallback, useEffect, useState } from 'react'
import { Container, Row, Col } from 'react-grid-system'
import { MdPeople } from 'react-icons/md'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import routes from '../../../config/routes'
import { USER_STATUS_TYPE } from '../../../constants/types'
import { request } from '../../../integration'
import Avatar from '../../commons/Avatar/Avatar'
import Flex from '../../commons/Flex/Flex'
import DefaultLayout from '../../commons/Layouts/DefaultLayout'
import LoadingBounce from '../../commons/LoadingBounce/LoadingBounce'
import SeeMoreButton from '../../commons/SeeMoreButton/SeeMoreButton'
import Text from '../../commons/Text/Text'
import PeopleEmpty from './PeopleEmpty'
import PeopleFilters from './PeopleFilters'
import styles from './peopleList.module.scss'

const showErrorsToast = (error) => {
  if (error.errors) {
    error.errors.map((message) => {
      toast.error(message)
    })
  }
}

const PeopleList = () => {
  const [loading, setLoading] = useState(false)
  const [superviseds, setSuperviseds] = useState([])
  const [amount, setAmount] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const [showPagination, setShowPagination] = useState(true)
  const [currentStatus, setCurrentStatus] = useState()

  const profile = useSelector((store) => store.currentUserReducer.profile)

  const getPerPage = () => {
    const width = window?.innerWidth ?? 1440
    let perPage = 10

    if (width > 1720) {
      perPage = 12
    }

    if (width > 2291) {
      perPage = 14
    }

    return perPage
  }

  const loadPeople = useCallback(
    async (status = null, page = null) => {
      setLoading(true)
      try {
        const params = {
          page,
          per_page: getPerPage()
        }

        if (status) {
          const filter = []

          if (status === 9) {
            filter.push(4)
            filter.push(6)
          } else {
            filter.push(status)
          }

          params.status = filter
        }

        const { data, metadata } = await request.get('v1/superviseds', {
          params
        })

        if (page != null) {
          setSuperviseds([...superviseds, ...data])
        } else {
          setSuperviseds(data)
        }

        setAmount(metadata?.pagination?.total)
        setCurrentPage(metadata?.pagination?.currentPage)
        setShowPagination(
          metadata?.pagination?.currentPage < metadata?.pagination?.lastPage
        )
      } catch ({ error }) {
        showErrorsToast(error)
      } finally {
        setLoading(false)
      }
    },
    [setSuperviseds, superviseds]
  )

  const handleFilter = useCallback(
    (status) => {
      setCurrentPage(null)
      setCurrentStatus(status)
      loadPeople(status)
    },
    [loadPeople]
  )

  const handlePaginate = () => {
    loadPeople(currentStatus, currentPage + 1)
  }

  useEffect(() => {
    loadPeople()
  }, [])

  return (
    <DefaultLayout>
      <Container fluid>
        <Row>
          <Text color="gray" size="lg" variation="dark" bold>
            Pessoas
          </Text>
        </Row>

        <Row style={{ paddingTop: 16, paddingBottom: 16 }}>
          <Col
            sm={9}
            md={9}
            lg={8}
            xxl={9}
            style={{ paddingLeft: 0, paddingRight: 30 }}
          >
            <div className={styles.identifier}>
              <Text
                size="lg"
                color="gray"
                variation="dark"
                value={`Olá, ${profile.name}`}
                extraBold
              />
              <Text
                size="sm"
                color="gray"
                font="custom"
                margin="14px 0px 0px 0px"
              >
                Faça a gestão e acompanhe o status dos seus consultores aqui.
              </Text>
            </div>
          </Col>

          <Col sm={3} md={3} lg={4} xxl={3} className={styles.amount}>
            <Flex
              alignItems="center"
              justifyContent="space-between"
              height="100%"
            >
              <Flex height="100%" column justifyContent="center">
                <Text
                  color="gray"
                  variation="lightest"
                  value={`${amount}`}
                  size="mlg"
                  font="custom"
                />
                <Text
                  color="gray"
                  variation="lightest"
                  value="Consultores contratados."
                  size="sm"
                  font="custom"
                />
              </Flex>
              <Flex
                alignItems="center"
                justifyContent="center"
                margin="0px 10px 0px 0px"
              >
                <MdPeople size={48} color="#737373" />
              </Flex>
            </Flex>
          </Col>
        </Row>

        <PeopleFilters handlerFilter={handleFilter} />

        <Row justify="center">
          {loading && <LoadingBounce />}
          {!loading && superviseds.length > 0 && (
            <Col style={{ paddingLeft: 0 }}>
              <div className={styles.list}>
                {superviseds.map((item) => {
                  const status = USER_STATUS_TYPE.find(
                    (element) =>
                      element.value ===
                      ([4, 6].includes(item.status) ? 9 : item.status)
                  )

                  return (
                    <Link
                      key={item.id}
                      className={styles.item}
                      to={routes.people.detail.generate(item.stdCode)}
                    >
                      <Row align="center">
                        <Col xs={3} xxl={3}>
                          <Avatar
                            image={item.profile_image_url}
                            title={item.name}
                            size="medium"
                          />
                        </Col>
                        <Col xs={8} xxl={7}>
                          <Text color="gray" variation="dark" size="xxs" bold>
                            {item.name}
                          </Text>
                        </Col>
                      </Row>
                      <Row style={{ marginTop: 20 }}>
                        <Col xs={12}>
                          <Text
                            size="xxs"
                            color="gray"
                            variation="dark"
                            font="custom"
                            weight="400"
                            lineHeight="20px"
                          >
                            Lojas na carteira: {`${item.totalStores}`}
                          </Text>
                        </Col>

                        <Col xs={12} style={{ marginTop: 8 }}>
                          <Flex>
                            <Text
                              size="xxs"
                              color="gray"
                              variation="dark"
                              font="custom"
                              weight="400"
                              lineHeight="20px"
                            >
                              Status:
                            </Text>
                            <Text
                              size="xxs"
                              color={status.color}
                              variation={status.variation}
                              font="custom"
                              weight="400"
                              lineHeight="20px"
                              margin="0px 4px"
                            >
                              {status.label}
                            </Text>
                          </Flex>
                        </Col>
                      </Row>
                    </Link>
                  )
                })}
              </div>
            </Col>
          )}
          {!loading && superviseds.length === 0 && <PeopleEmpty />}
        </Row>
        {!loading && showPagination && superviseds.length > 0 && (
          <Row justify="center" style={{ marginTop: 20 }}>
            <SeeMoreButton handlePaginate={handlePaginate} />
          </Row>
        )}
      </Container>
    </DefaultLayout>
  )
}

export default PeopleList
